require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-forchtenstein.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-forchtenstein");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-forchtenstein!./.cache/json/betreuungseinrichtungen-mattersburg-forchtenstein.json
// module id = 927
// module chunks = 231608221292675